import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  changePassword,
  editProfile,
  getProfileDetails,
} from "../services/accountServices";

// Async action to fetch profile
export const fetchUserData = createAsyncThunk(
  "account/fetchUser",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getProfileDetails();
      return response.data; // Assuming response.data is the profile object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editProfileData = createAsyncThunk(
  "account/editUserdata",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await editProfile(userData);
      return response.data; // Assuming response.data is the profile object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  "account/changePassword",
  async (passwordData, { rejectWithValue }) => {
    try {
      const response = await changePassword(passwordData);
      return response.data; // Assuming response.data is the profile object
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const accountSlice = createSlice({
  name: "account",
  initialState: {
    profile: null, // Changed from [] to null
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle profile data
      .addCase(fetchUserData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserData.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.profile = action.payload; // Store profile as an object instead of an array
        }
      })
      .addCase(fetchUserData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle update profile
      .addCase(editProfileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileData.fulfilled, (state, action) => {
        state.loading = false;
        //set updated profile data
        if (action.payload) {
          state.profile = action.payload; // Update profile with new data
        }
      })
      .addCase(editProfileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Handle Change password
      .addCase(changeUserPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeUserPassword.fulfilled, (state, action) => {
        state.loading = false;
        //handle fulfilled case
      })
      .addCase(changeUserPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accountSlice.reducer;
